import { Link } from "react-router-dom";

const ErrorPage = () => {
    return (
        <div id="ErrorPage" className="w-10/12 mx-auto flex flex-col items-center justify-center pb-40">
            <h2 className="text-4xl font-semibold dark:text-white">Page not Found...</h2>
        </div>
    );
}

export default ErrorPage;